
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import SearchFilter from "./SearchFilter.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import Icon from "@/components/UI/Icon.vue";

export type SearchBoxState = {
  query: string;
  modifiedOnly: boolean;
  includeSettings?: boolean;
};

@Component({
  components: { SearchFilter, TextInput, Icon }
})
export default class SearchBox extends Vue {
  @Prop()
  value!: SearchBoxState;

  @Prop()
  includeSettingsToggle!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  location!: "element" | "settings" | "selector" | string;

  emit(newState: SearchBoxState) {
    this.$emit("input", newState);
  }

  editQuery(newQuery: string | null) {
    if (typeof newQuery === "string") {
      this.emit({
        ...this.value,
        query: newQuery.trim().toLowerCase()
      });
    } else {
      this.emit({
        ...this.value,
        query: ""
      });
    }
  }

  clearQuery() {
    this.emit({
      ...this.value,
      query: "",
      modifiedOnly: false
    });
  }

  editModified(modified: boolean) {
    this.emit({
      ...this.value,
      modifiedOnly: modified
    });
  }

  editSettings(settings: boolean) {
    this.emit({
      ...this.value,
      includeSettings: settings
    });
  }

  get placeholder() {
    return "Search";
  }
}
